import { ref } from 'vue';
import { tryOnScopeDispose } from '@vueuse/core';
import { socket } from '@/services/websocket.ts';

export default function useWebSockets() {
    const subs = ref([]);

    function on(channel, handler, timeout = 0) {
        socket.on(channel, handler, timeout);

        if (subs.value.includes(channel)) return;

        subs.value.push(channel);
    }

    function off(channel, handler) {
        socket.off(channel, handler);

        subs.value = subs.value.filter(ch => ch !== channel);
    }

    function emit(channel, data, unique = false) {
        socket.emit(channel, data, unique);
    }

    function clear() {
        if (!subs.value.length) return;

        socket.clear(...subs.value);

        subs.value = [];
    }

    tryOnScopeDispose(clear);

    return {
        subs,
        on,
        off,
        emit,
        clear,
    };
}
